const apiUrl = process.env.REACT_APP_API_URL;

export const EnsureCazaJavamon = async (cazaId: string, userId: string, idConjunt?: number | null) => {
    try {
        // Note: Controller path is /caza/ensure, NOT /jutge/caza/ensure
        const conjuntParam = idConjunt != null ? `&idConjunt=${idConjunt}` : '';
        const response = await fetch(`${apiUrl}:8061/caza/ensure?idCaza=${cazaId}&idUsuari=${userId}${conjuntParam}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const data = await response.json();
            // Backend returns List<Javamon>, so it's an array.
            if (Array.isArray(data) && data.length > 0) {
                return data[0];
            }
            return data;
        }
        return null;
    } catch (error) {
        console.error("Error ensuring javamon", error);
        return null;
    }
}
